import React, { FC } from 'react'

import { Flex } from '../box'
import { Text } from '../text'

type Props = {
  value?: string
}

export const Notation: FC<Props> = ({ value }: Props) => {
  if (!value) return null

  return (
    <Flex alignItems='center' justifyContent='center' mr={4}>
      <Text color='neutral-dark-20'>{value}</Text>
    </Flex>
  )
}
